import { DynamicFormFieldModel, DynamicFormModel } from 'models';

import { ApiRouteService } from '../services';
import { HttpClient } from './HttpClient';

export class DynamicFormsClient {
  constructor(private httpClient: HttpClient) {
    this.getDynamicFormFor = this.getDynamicFormFor.bind(this);
    this.getDynamicFormsFor = this.getDynamicFormsFor.bind(this);
    this.setDynamicFormFor = this.setDynamicFormFor.bind(this);
    this.GetFormSubmissions = this.GetFormSubmissions.bind(this);
    this.updateDynamicFormSubmission = this.updateDynamicFormSubmission.bind(this);
  }

  public async getDynamicFormFor(entityType: string, entityId: number) {
    const options = await this.httpClient.createStandardOptions('GET', null);
    const form = await this.httpClient.fetchAndParse<DynamicFormModel>(
      fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/dynamic-forms/${encodeURIComponent(entityType)}/${entityId}`, options),
    );
    return form;
  }

  public async getDynamicFormsFor(entityType: string, entityIds: number[]) {
    const options = await this.httpClient.createStandardOptions('GET', null);
    const entityIdParams = entityIds.map((id) => `entityIds=${id}`).join('&');
    const response = await this.httpClient.fetchAndParse<DynamicFormModel[]>(
      fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/dynamic-forms/${encodeURIComponent(entityType)}?${entityIdParams}`, options),
    );
    return response;
  }

  public async setDynamicFormFor(model: DynamicFormModel) {
    const options = await this.httpClient.createStandardOptions('POST', model);
    await this.httpClient.fetch(
      fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/dynamic-forms/${encodeURIComponent(model.entityType)}/${model.entityId}`, options),
    );
  }

  public async GetFormSubmissions(entityType: string, entityIds: number[]) {
    const options = await this.httpClient.createStandardOptions('GET', null);
    const entityIdParams = entityIds.map((id) => `entityIds=${id}`).join('&');
    const response = await this.httpClient.fetchAndParse<DynamicFormModel[]>(
      fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/dynamic-forms/${encodeURIComponent(entityType)}/Submissions?${entityIdParams}`, options),
    );
    return response;
  }

  public async updateDynamicFormSubmission(submissionId: number, fields: DynamicFormFieldModel[]) {
    const options = await this.httpClient.createStandardOptions('PUT', fields);
    await this.httpClient.fetch(fetch(`${ApiRouteService.getCompumedApiBaseRoute()}/api/dynamic-forms/submission/${submissionId}`, options));
  }
}
